import React from "react";
import NotFoundIMG from './../../Images/404.png'
import './NotFound.css';

const NotFound = () => {
  return (
    <>
      <div className="center">
        <h1>Lo sentimos!</h1>
        <img src={NotFoundIMG} alt="not-found"/>
      </div>
    </>
  )
}

export default NotFound;